<div class="fixed bottom-5 right-5 z-[9999] max-w-sm">
    @if (toasts$ | async; as toasts) {
        @if (toasts.length > 0) {
            <div class="flex flex-col-reverse gap-3">
                @for (toast of toasts; track trackToast($index, toast); let i = $index) {
                    <button
                            (click)="removeToast(toast.id)"
                            [class]="getToastClasses(toast.type)"
                            class="w-full"
                    >
                        <div class="flex-1 text-left">
                            @if (toast.title && toast.subtitle) {
                                <div class="font-bold text-sm mb-1">{{ toast.title }}</div>
                                <div class="text-xs opacity-90">{{ toast.subtitle }}</div>
                            } @else {
                                <span>{{ toast.message }}</span>
                            }
                        </div>
                        <div class="ml-4 opacity-80 text-lg font-bold leading-none cursor-pointer p-1 rounded transition-all duration-200 hover:opacity-100 hover:bg-white/20">
                            ×
                        </div>
                    </button>
                }
            </div>
            @if (toasts.length > 1) {
                <button
                        (click)="clearAllToasts()"
                        class="btn btn-sm btn-ghost mb-2 w-full">
                    Clear All ({{ toasts.length }})
                </button>
            }

        }
    }
</div>
